<template>
  <DeployerViewDeployOracle :white-label="whitelabelStore.config"/>
</template>

<script setup>
const whitelabelStore = useWhitelabelStore()
</script>

<style lang="scss" scoped></style>
